var _defs, _path, _line, _line2, _polyline, _line3, _line4, _line5, _polyline2, _rect, _path2, _path3, _ellipse, _path4, _line6, _line7, _line8, _line9, _path5, _path6, _polyline3, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;opacity:0.29;}.cls-2,.cls-7,.cls-8{fill:#fff;}.cls-2,.cls-3,.cls-8{stroke:#3c4650;stroke-linejoin:round;}.cls-2,.cls-3,.cls-6,.cls-8,.cls-9{stroke-linecap:round;}.cls-3,.cls-9{fill:none;}.cls-4{fill:#bdc3c9;}.cls-5{fill:#dfe5e9;}.cls-6{fill:#ffaa96;stroke:#212c38;}.cls-6,.cls-9{stroke-miterlimit:10;}.cls-8{stroke-width:0.75px;}.cls-9{stroke:#ff4338;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "verified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.79,146.59A30.27,30.27,0,0,1,90,116.28c.75,0,1.5,0,2.24.09a34.11,34.11,0,0,1-.38-5.07,33.68,33.68,0,0,1,4.81-17.45c.57-1-.28-3.31-1.37-3.51a32.28,32.28,0,0,0-35.26,19.15A23.3,23.3,0,0,0,26.93,134c-.51,0-1-.06-1.54-.06a20.83,20.83,0,0,0,.05,41.66l55.89-.07A30.28,30.28,0,0,1,59.79,146.59Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.12,
    y1: 127.15,
    x2: 199.46,
    y2: 127.15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.07,
    y1: 117.48,
    x2: 144.56,
    y2: 112.42
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "221.61 117.2 175.77 150.78 129.93 117.2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.12,
    y1: 133.68,
    x2: 199.46,
    y2: 133.68
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.12,
    y1: 140.21,
    x2: 204.11,
    y2: 140.21
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 152.12,
    y1: 146.74,
    x2: 199.46,
    y2: 146.74
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "129.93 117.48 144.56 112.42 211.12 112.42 221.61 117.48"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 140.9,
    y: 82.48,
    width: 73,
    height: 90.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.75,173.55H134.17c-2.34,0-4.24-1.11-4.24-2.49V117.2l45.84,28.18,45.84-28.18V171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.61,171s.72,2.56-4.29,2.56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 211.12,
    cy: 82.48,
    rx: 12.4,
    ry: 12.62
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M205.92,80.12l3.59,3.67,7.39-7.55,2.49,2.54-9.77,9.95-6.08-6.19Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 152.12,
    y1: 107.56,
    x2: 204.11,
    y2: 107.56
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 152.12,
    y1: 114.09,
    x2: 200.94,
    y2: 114.09
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 152.12,
    y1: 120.62,
    x2: 203.52,
    y2: 120.62
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 152.12,
    y1: 127.15,
    x2: 200.94,
    y2: 127.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157,94.28v1.16c0,.1,0,.84-.72.84h-.81c-.62,0-.65-.63-.65-.84V94.28Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M174.47,91.34h-22v4.6c0,.78.11,3.13,2.42,3.13h1.61c2.68,0,2.69-2.74,2.69-3.13V94.28H168v3.35h-2.51"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "174.47 94.28 170.96 94.28 170.96 97.63 173.22 97.63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.65,127.31V170a4.18,4.18,0,0,1-4.14,4.22H157.77"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.28,174.65h90.31a3.3,3.3,0,0,0,3.3-3.3l.18-9.2V117.48l45.14,28.84a3.14,3.14,0,0,0,4.07-.34l42.34-27.55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.17,67.2c-8.54-12.5-23.89-20.84-41.41-20.84-20,0-37.25,10.92-44.66,26.5a38.18,38.18,0,0,0-15.22-3.12,36.69,36.69,0,0,0-26.63,11"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.92,174.93a21.24,21.24,0,0,1,0-42.48c.53,0,1.05,0,1.57.06A23.77,23.77,0,0,1,50,105.21a23.66,23.66,0,0,1,10.32,2.35,32.92,32.92,0,0,1,29.48-20h.8s5.13.3,3.34,5.31c-1.6,4.48-3,9.16-3,14.23a35.18,35.18,0,0,0,.39,5.22c-.76-.06-1.53-.09-2.31-.09a31.18,31.18,0,0,0-19.52,55.5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.46,105.92c0-.06,0-.11,0-.17,0-23.21-18-42-40.18-42a38.48,38.48,0,0,0-18,4.5c-2.32.65-1.51,4.75-.84,6.3a51.21,51.21,0,0,1,4.13,20.17c0,.07,0,.13,0,.2C255.4,96.81,271,114.29,271,135.61c0,19.16-12.53,35.25-29.5,39.72l46-.06c18.33,0,33.16-15.6,33.14-34.79C320.59,122.37,307.34,107.52,290.46,105.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252,166.1a42,42,0,0,0,17.39-34.26c0-21.53-15.72-39.2-35.8-41.13,0-.07,0-.13,0-.2a44,44,0,0,0-2.45-15.84c-2-5.35-.44-6.42,2.62-8a38.17,38.17,0,0,1,17.88-4.36c22.31,0,40.4,18.94,40.4,42.31,0,.06,0,.11,0,.17,17,1.63,30.31,16.6,30.31,34.83,0,19.32-15,35-33.4,35h-25.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.a8ae8ad914120f8002adec8683ced401.svg";
export { ForwardRef as ReactComponent };